(function () {
  const LOTTIE_SCRIPT_URL =
    'https://cdn.jsdelivr.net/npm/lottie-web@5.12.2/build/player/lottie.min.js';

  let lottieScriptPromise;

  function loadLottieScript() {
    if (window.lottie) {
      return Promise.resolve(window.lottie);
    }

    if (lottieScriptPromise) {
      return lottieScriptPromise;
    }

    lottieScriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = LOTTIE_SCRIPT_URL;
      script.async = true;
      script.onload = () => resolve(window.lottie);
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return lottieScriptPromise;
  }

  function initComparisonTableLottie(root = document) {
    const containers = root.querySelectorAll(
      '[data-comparison-table-lottie]:not([data-lottie-ready])'
    );

    if (!containers.length) {
      return;
    }

    loadLottieScript()
      .then((lottie) => {
        containers.forEach((container) => {
          const src = container.dataset.lottieSrc;

          if (!src) {
            return;
          }

          lottie.loadAnimation({
            container,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: src,
            rendererSettings: {
              preserveAspectRatio: 'xMidYMin meet',
            },
          });

          container.dataset.lottieReady = 'true';
        });
      })
      .catch(() => {});
  }

  initComparisonTableLottie();

  document.addEventListener('shopify:section:load', (event) => {
    initComparisonTableLottie(event.target);
  });
})();
